import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-191d4d9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = {
  key: 0,
  class: "share_btn__wrapper"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  class: "summary__results_table",
  "data-test": "summary-results-table"
}
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_share_svg = _resolveComponent("app-share-svg")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (!_ctx.fromRecovery)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t("ex.summary.go_to")) + " ", 1),
          _createVNode(_component_router_link, { to: { name: 'BreathingExercise-Start' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("ex.title")), 1)
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("ex.summary.and_start_breathing")), 1)
        ]))
      : (_ctx.holdTimes.length === _ctx.numberOfRounds)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.$t("ex.summary.congrats_finished")), 1))
        : (_ctx.holdTimes.length === 0)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.$t("ex.summary.no_rounds_finished")), 1))
          : (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.$t("ex.summary.breathing_finished")), 1)),
    (_ctx.holdTimes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.canShare)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.share && _ctx.share(...args))),
                  ref: "shareBtn",
                  class: "share_btn",
                  title: _ctx.$t('ex.summary.share_results')
                }, [
                  _createVNode(_component_app_share_svg)
                ], 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.holdTimes, (time, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("ex.summary.round_with_num", [idx + 1])), 1),
                _createElementVNode("td", null, _toDisplayString(time) + " s", 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.holdTimes.length > 1)
      ? (_openBlock(), _createElementBlock("p", {
          key: 5,
          class: "average",
          innerHTML: _ctx.$t('ex.summary.averageTime', [_ctx.averageTime])
        }, null, 8, _hoisted_10))
      : _createCommentVNode("", true)
  ]))
}